export interface FlexLayoutFieldConfig {
    fieldName: string;
    col: number;
    row: number;
    colspan?: number;
    rowspan?: number;
    maxCollapsedWidth?: number;
    flex?: string;
    layoutAlign?: string;
    class?: string;
    width?: string;
    minWidth?: string;
    maxWidth?: string;
}
